import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { CommunicationService } from '../../api/services';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Select } from 'primeng/select';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MessageService } from 'primeng/api';
import { Message } from 'primeng/message';
import { AuthService } from '@core/service/auth.service';
import { FileUpload } from 'primeng/fileupload';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-cadastro-intituicao-ensino',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    Select,
    InputTextModule,
    ButtonModule,
    CheckboxModule,
    RadioButtonModule,
    FileUpload,
    TextareaModule,
    ToastModule
  ],
  providers: [AuthService, MessageService, DialogService],
  templateUrl: './cadastro-intituicao-ensino.component.html',
  styleUrls: ['./cadastro-intituicao-ensino.component.scss'],
  standalone: true,
})
export class CadastroIntituicaoEnsinoComponent implements OnInit, OnDestroy {
  institutuicaoEnsinoForm!: FormGroup;

  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  config = inject(DynamicDialogConfig);
  ref = inject(DynamicDialogRef);
  private fb = inject(FormBuilder);
  private communicationService = inject(CommunicationService);
  private authService = inject(AuthService);
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  typeofEducationalInstitution: any[] = [];
  naturezaOptions: any[] = [];
  private subscriptions = new Subscription();
  isInternalInstitution: boolean = false;

  prefix = '';
  isEditMode = false;

  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;

  constructor() {
    this.institutuicaoEnsinoForm = this.fb.group({
      Nome: ['', Validators.required],
      TipoInstituicao: ['', Validators.required],
      Sigla: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      NumIdentificacao: ['', Validators.required],
      paisID: ['', Validators.required],
      ProvinciaID: ['', Validators.required],
      MunicipioID: ['', Validators.required],
      categoriaInstituicaoEnsinoID: [2, Validators.required],
      Endereco: ['', Validators.required],
      Telefone: ['', Validators.required],
      Foto: [''],
      Email: ['', [Validators.required, Validators.email]],
      Natureza: ['', Validators.required],
      IsActive: [true],
      DescricaoEmpresa: [''],
    });

    this.institutuicaoEnsinoForm.controls['paisID'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onCountryChange(value);
      }
    );

    this.institutuicaoEnsinoForm.controls['ProvinciaID'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onProvinceChange(value);
      }
    );

    this.institutuicaoEnsinoForm.controls[
      'TipoInstituicao'
    ].valueChanges.subscribe((value) => {
      // if (!value ^^) return;
      this.isInternalInstitution = value === 0; // 'INTERNA' is selected 'endereco', 'telefone', 'email'
      // if (!value ^^) return;
      this.isInternalInstitution = value === 0; // 'INTERNA' is selected 'endereco', 'telefone', 'email'
      if (this.isInternalInstitution) {
        ['Nome'].forEach((control) => {
          // this.institutuicaoEnsinoForm.get(control)?.disable();
        });

        // Ajusta a validação do campo 'numIdentificacao' para instituições internas
        // this.institutuicaoEnsinoForm
        //   .get('NumIdentificacao')
        //   ?.setValidators([Validators.required, Validators.minLength(7)]);
      } else {
        ['Nome'].forEach((control) => {
          this.institutuicaoEnsinoForm.get(control)?.enable();
        });

        // Ajusta a validação do campo 'numIdentificacao' para instituições externas
        // this.institutuicaoEnsinoForm
        //   .get('NumIdentificacao')
        //   ?.setValidators([Validators.required, Validators.minLength(7)]);
      }

      // Actualiza as validações
      // this.institutuicaoEnsinoForm
      //   .get('NumIdentificacao')
      //   ?.updateValueAndValidity();
    });

    this.countries = this.config.data.countries;
    this.provinces = this.config.data.provinces;
    this.municipalities = this.config.data.municipalities;

    this.typeofEducationalInstitution =
      this.config.data.typeofEducationalInstitution;
    this.naturezaOptions = this.config.data.naturezaOptions;
  }

  ngOnInit(): void {
    if (
      this.config.data.profileEducationalInstitution &&
      this.config.data.profileEducationalInstitution.id
    ) {
      this.loadInstitutionDetails(
        this.config.data.profileEducationalInstitution
      );
      this.isEditMode = true;
    }

    this.subscriptions.add(
      this.communicationService.provinces$.subscribe((provinces) => {
        this.provinces = provinces;
      })
    );
    this.subscriptions.add(
      this.communicationService.municipalities$.subscribe((municipalities) => {
        this.municipalities = municipalities;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  loadInstitutionDetails(profileEducationalInstitution: any): void {
    this.institutuicaoEnsinoForm.patchValue({
      id: profileEducationalInstitution.id,
      Nome: profileEducationalInstitution.nome,
      TipoInstituicao: Number(profileEducationalInstitution.tipoInstituicaoEnsinoValueEnum || 0),
      Sigla: profileEducationalInstitution.sigla,
      NumIdentificacao: profileEducationalInstitution.numIdentificacao,
      paisID: profileEducationalInstitution.paisID ?? 193,
      ProvinciaID: profileEducationalInstitution.provinciaID,
      MunicipioID: profileEducationalInstitution.municipioID,
      Endereco: profileEducationalInstitution.endereco,
      Telefone: profileEducationalInstitution.telefone,
      Email: profileEducationalInstitution.email,
      Natureza: profileEducationalInstitution.naturezaValueEnum || 0,
      IsActive: profileEducationalInstitution.isActive,
      DescricaoEmpresa: profileEducationalInstitution.descricaoEmpresa,
    });

    if (this.config.data.imagePreview) {
      this.imagePreview = this.config.data.imagePreview;
    }

    if (profileEducationalInstitution.id) {
      const fotoBlob: Blob | null = this.config.data.fotoBlob ?? null;

      if (fotoBlob) {
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result as string;
        };
        reader.readAsDataURL(fotoBlob);
      }
    }
  }

  onCountryChange(value: any) {
    this.communicationService.emitCountryChanged(value);
    // this.resetProvinceAndMunicipality();
  }

  resetProvinceAndMunicipality() {
    this.institutuicaoEnsinoForm.patchValue({
      ProvinciaID: null,
      MunicipioID: null,
    });
  }

  resetMunicipality() {
    this.institutuicaoEnsinoForm.patchValue({
      MunicipioID: null,
    });
  }

  onProvinceChange(value: any) {
    this.communicationService.emitProvinceChanged(value);
    // this.resetMunicipality();
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.institutuicaoEnsinoForm.patchValue({ Foto: this.file });

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
    /*this.file = event.currentFiles[0];
    console.log(this.file);
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result; // Store Base64 URL
    };
    reader.readAsDataURL(this.file);*/
  }

  searchNif(): void {
    this.authService
      .getInfoByNif(
        this.institutuicaoEnsinoForm.controls['NumIdentificacao']
          .value as string
      )
      .subscribe((result) => {
        console.log(result);
        if (result.retorno.codigo === 200) {
          const moradaPrincipal = result.data.moradaPrincipal || {};
          const isCompany = !!result.data.nomeColectivo;
          const isIndividual = !!result.data.nomeContribuinte;

          const email =
            result.data.listaReprLegal?.reprLegal[0]?.emailRepLegal ||
            result.data.listaEmail?.email[0];
          const telefone = result.data.contactoPrincipal
            .numeroContacto as string;

          if (isCompany) {
            this.institutuicaoEnsinoForm.patchValue({
              Nome: result.data.nomeColectivo,
              Endereco: `${moradaPrincipal.municipio} ${moradaPrincipal.bairro} ${moradaPrincipal.morada}`,
              Telefone: telefone,
              Email: email,
            });
          } else if (isIndividual) {
            this.institutuicaoEnsinoForm.patchValue({
              Nome: result.data.nomeContribuinte,
              Endereco: `${moradaPrincipal.municipio} ${moradaPrincipal.bairro} ${moradaPrincipal.morada}`,
              Telefone: telefone,
              Email: email || '',
            });
            this.institutuicaoEnsinoForm.controls['Email'].enable();
          }

          if (!email) {
            this.institutuicaoEnsinoForm.controls['Email'].enable();
          }
          if (!telefone) {
            this.institutuicaoEnsinoForm.controls['Telefone'].enable();
          }
          // Disable the fields after autofill 'endereco', 'telefone'
          ['Nome'].forEach((control) => {
            this.institutuicaoEnsinoForm.get(control)?.enable();
          });
        } else {
          console.error(
            'Erro ao buscar informações pelo NIF:',
            result.retorno.message
          );
        }
      });
  }

  save(): void {
    if (this.institutuicaoEnsinoForm.valid) {
      const rawData = this.institutuicaoEnsinoForm.getRawValue();
      const formData = new FormData();
      formData.append('DescricaoEmpresa', rawData.DescricaoEmpresa);
      if (rawData.Foto) {
        formData.append('Foto', rawData.Foto);
      }
      formData.append('Sigla', rawData.Sigla);
      formData.append('ProvinciaID', rawData.ProvinciaID.toString());
      formData.append('MunicipioID', rawData.MunicipioID.toString());
      formData.append('Endereco', rawData.Endereco);
      formData.append('Telefone', rawData.Telefone);
      formData.append('Natureza', rawData.Natureza.toString());
      formData.append('IsActive', rawData.IsActive.toString());
      formData.append('NumIdentificacao', rawData.NumIdentificacao);
      formData.append('TipoInstituicao', rawData.TipoInstituicao.toString());
      formData.append('Nome', rawData.Nome);
      formData.append('Email', rawData.Email);

      this.ref.close(formData); // envia o FormData para o componente pai
    } else {
      if (this.institutuicaoEnsinoForm.invalid) {
        this.institutuicaoEnsinoForm.markAllAsTouched();
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Por favor, preencha todos os campos obrigatórios.',
        });
        return;
      }
      this.institutuicaoEnsinoForm.markAllAsTouched();
      if (!this.selectedFile) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Por favor selecione uma imagem para o logotipo.',
        });
      }
    }
  }

  cancel() {
    this.ref.close();
  }
}
